import { useEffect, useState } from "react";
import { api } from "../api/client";

// Customer feedback that the CMS has approved for the public website.
//
// Optional by design, exactly like usePageContent: the testimonials section
// falls back to its curated default quotes while the request is in flight, on
// error, or when nothing has been published yet — a temporary API outage
// never blanks the home page.
export default function usePublishedFeedback() {
  const [feedback, setFeedback] = useState([]);

  useEffect(() => {
    let cancelled = false;
    api
      .listPublishedFeedback()
      .then((data) => {
        if (!cancelled) setFeedback(data?.feedback || []);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  return feedback;
}
